<template>
  <q-card
    bordered
    flat
    style="max-width:600px"
  >
    <q-card-section class="column items-center">
      <q-avatar
        color="primary"
        text-color="white"
        :icon="icon"
        size="100px"
      />
    </q-card-section>
    <q-card-section class="text-center">
      <h5 class="text-primary q-ma-none">{{ title }}</h5>
    </q-card-section>
    <q-card-section class="text-center">
      <slot name="text">
        <p>{{ text }}</p>
      </slot>
    </q-card-section>
    <q-card-section align="center">
      <slot name="actions">
        <q-btn
          v-for="action,i of actions"
          :key="i"
          unelevated
          class="wlk-btn"
          color="primary"
          v-bind="action"
        />
      </slot>
    </q-card-section>
  </q-card>
</template>
<script>

export default {
  name: 'MeterReadingError',
  props: {
    icon: {
      type: String,
      default: () => 'app:cloud-attention'
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: () => null
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  setup () {
    return {
    }
  }
}
</script>
